/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
// import CrossIcon from "../../../../assets/svg/CrossIcon";
// import Button from "../../../../components/common/Button";
import styles from "./SearchForm.styles";
import Button from "../../../../components/Layout/Button";
import CrossIcon from "../../../../components/Svg/CrossIcon";

function SearchForm({ onClose, children, heading, showButton = true }) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>{heading}</div>
        <div style={styles.close} onClick={onClose}>
          <CrossIcon />
        </div>
      </div>
      <hr style={styles.divider} />
      <div style={styles.body}>{children}</div>
      {showButton && (
        <div style={styles.footer}>
          <Button label="Search" type="submit">
            Search
          </Button>
        </div>
      )}
    </div>
  );
}

export default SearchForm;
